app.component("aiDocumentsView", {
	templateUrl: "app/src/js/components/aiDocuments/aiDocuments.html",
	controller: "aiDocumentsController",
	bindings: {
		data: "=",
	},
});

app.controller("aiDocumentsController", [
	"$scope",
	"$modal",
	"ElevenLabsAPI",
	"FileUploader",
	"ELEVEN_LABS_AI_TOUR_1261",
	function ($scope, $modal, ElevenLabsAPI, FileUploader, ELEVEN_LABS_AI_TOUR_1261) {

		$scope.API = ElevenLabsAPI;
		$scope.availableDocuments = [];

		$scope.popoverDelete = {
			content: "Delete",
		};

		$scope.popoverEdit = {
			content: "Edit",
		};

		$scope.uploader = new FileUploader({
			queueLimit: 1,
		});


		this.$onInit = function () {
			$scope.showEdit = false;
			$scope.documentObj = { name: '', type: 'TEXT' }
			fetchDocuments();
		};

		function fetchDocuments() {
			$scope.API.isProcessing = true;
			$scope.API.getDocuments()
				.then(
					(resp) => {
						$scope.availableDocuments = resp.data;
					},
					(error) => {
						showGenericErrorModal();
					}
				)
				.then(() => ($scope.API.isProcessing = false));
		}

		$scope.openDeleteModal = (item) => {
			$scope.negativeButton = null;
			$scope.onGeneralClick = function () {
				if ($scope.generalModal) {
					$scope.generalModal.hide();
					$scope.negativeButton = null;
				}
				deleteDocument(item);
			};
			$scope.generalModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.general.tpl.html",
				show: true,
				title: "Delete AI Agent",
				content: "Are you sure you want to delete this document?",
				backdrop: true,
				keyboard: false,
			});
		};

		function showGenericErrorModal() {
			if ($scope.serverErrorModal) {
				$scope.serverErrorModal.hide();
			}
			$scope.serverErrorModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
				show: true,
				title: "CatTrax has encountered an error",
				keyboard: false,
				backdrop: "static",
				onHide: function () {
					angular.element("body").removeClass("modal-open").css("overflow", "auto");
				},
			});
		}

		$scope.editDocument = (item) => {
			$scope.showEdit = true;
			$scope.documentObj = {
				document_id: item.document_id,
				name: item.name,
				type: item.type,
				text: item.text || item.content,
				url: item.url
			};
			$scope.uploader.clearQueue();
		};

		$scope.goBack = () => {
			$scope.showEdit = false;
		}

		$scope.createDocument = () => {
			$scope.documentObj = { name: '', type: 'TEXT' };
			$scope.uploader.clearQueue();
			$scope.showEdit = true;
			setTimeout(()=>{
				setupOnboard();
			},1000);
		}

		$scope.saveDocument = () => {
			const formData = new FormData();
			formData.append("name", $scope.documentObj.name);
			formData.append("type", $scope.documentObj.type);

			if ($scope.documentObj.type === "TEXT") {
				formData.append("text", $scope.documentObj.text);
			} else if ($scope.documentObj.type === "URL") {
				formData.append("url", $scope.documentObj.url);
			} else if ($scope.documentObj.type === "FILE") {
				if ($scope.documentObj.fileBlob) {
					formData.append("file", $scope.documentObj.fileBlob);
				}
			}

			$scope.API.isProcessing = true;

			let apiPromise;
			if ($scope.documentObj.document_id) {
				apiPromise = $scope.API.updateDocument($scope.documentObj.document_id, formData);
			} else {
				apiPromise = $scope.API.createDocument(formData);
			}

			apiPromise.then(
				(resp) => {
					$scope.goBack();
					fetchDocuments();
				},
				(error) => showGenericErrorModal()
			)
				.then(() => {
					$scope.API.isProcessing = false;
				});
		};

		function deleteDocument(item) {
			$scope.API.isProcessing = true;
			$scope.API.deleteDocument(item.document_id).then(
				(resp) => {
					fetchDocuments()
				},
				(error) => showGenericErrorModal()
			).then(() => {
				$scope.API.isProcessing = false;
			})
		}

		$scope.uploader.onAfterAddingFile = function (fileItem) {
			const type = fileItem._file.type;
			readFileInputEventAsArrayBuffer(fileItem._file, function (data) {
				var blobData = [data];
				var blob = new Blob(blobData, { type });
				// FileReader calls back outside Angular, so apply for the file name to show.
				$scope.$applyAsync(function () {
					$scope.documentObj.fileBlob = blob;
					$scope.documentObj.name = fileItem._file.name;
					$scope.uploader.clearQueue();
				});

			});
		};

		function readFileInputEventAsArrayBuffer(file, callback) {
			var reader = new FileReader();

			reader.onload = function (loadEvent) {
				var arrayBuffer = loadEvent.target.result;
				callback(arrayBuffer);
			};

			reader.readAsArrayBuffer(file);
		}

		function setupOnboard() {
			if(!ELEVEN_LABS_AI_TOUR_1261){
                return;
            }
			introJs
				.tour()
				.setOptions({
					steps: [
						{
							title: 'Add document name',
							element: document.getElementById("name"),
							intro: "This step focuses on an element",
						},
						{
							title: 'Add document type',
							element: document.getElementById("document_type"),
							intro: "This step focuses on an element",
						},
						{
							title: 'Add document text',
							element: document.getElementById("content"),
							intro: "This step focuses on an element",
						},
					],
					tooltipClass: "intro-customTooltip",
					dontShowAgain: true,
					showBullets: false
				})
				.start();
		}

	},
]);